import {Image, useWindowDimensions, View} from "react-native";
import {TouchableOpacity} from "react-native-gesture-handler";
import {FontAwesome5} from "@expo/vector-icons";
import * as React from "react";

export const Header = ({
                           onOpenUpdateUser
                       }) => {
        const { width } = useWindowDimensions()
        return <View style={{zIndex: 1}}>
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingLeft: 30,
                paddingRight: 30,
                alignItems: 'center',
                backgroundColor: 'white',
                height: 150,
                zIndex: 1
                }}>

                <View style={{ zIndex: 1, flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', bottom: -30 }}>
                    <Image style={{height: 100, width: 100, resizeMode: 'cover', aspectRatio: 1}}
                           source={require("../../assets/images/logo-wecycle-solo.png")}></Image>

                    {onOpenUpdateUser && <TouchableOpacity onPress={onOpenUpdateUser}>
                        <Image source={require('../../assets/images/layout/profile.png')} />
                        {/*<FontAwesome5 style={{marginRight: 10}} name="user-alt" size={24} color="#405066"/>*/}
                    </TouchableOpacity>}
                </View>
            </View>
            <Image source={require('../../assets/images/layout/header-wave.png')} style={{ width: width, height: width * 62 / 1078 }} />
    </View>
}